/*! Goldtop - the Customer Reviews "Show More" button, taken over from Judge.me.
    Loaded on every page from snippets/goldtop-tokens.liquid; does nothing at
    all unless a Judge.me review widget is on the page.

    ==================================================================
    WHY THIS EXISTS. THE APP'S OWN BUTTON IS BROKEN, AND IT IS NOT OUR DOING.

    Joe, 29 Sep, the morning after PDP v2.1 went live: "on the SHOW MORE button
    doesn't work as planned".

    MEASURED on the live site. Tapping Show More fires Judge.me's own request:

      GET cdn.judge.me/reviews/reviews_for_widget?page=2&per_page=6&product_id=...
        -> 200, 22,764 bytes
        -> { reviews: [ ...6 real reviews... ],
             pagination: { total_pages: 16, current_page: 2, per_page: 6 } }

    The request SUCCEEDS. The widget then renders none of it, removes its own
    .jdgm-paginate block, and logs nothing. The six review ids in the DOM are
    identical before and after. One dead tap and the rest of the reviews are
    unreachable: 6 of 91 on the '76 jacket, 6 of 160 on the Predator, 6 of 62
    on the Bobber.

    IT IS NOT OUR CODE, established with three independent controls, because
    this project has already made the mistake of calling something app-side on
    one session's evidence:

      1. Joe saw it first, on his own device, before I looked.
      2. It reproduces on theme 195282207102 - the pre-PDP-v2 build, previewed
         with none of our files loaded, html class "js supports-touch", no
         gt-v2. Six before, six after, button gone.
      3. It reproduces at 1440px on the live theme, where our controller's
         width-gated work does not run at all.

    THE LIKELY CAUSE, stated as the inference it is: the widget is a Judge.me
    app block loading the v3 asset bundle (widget_v3_base.css, widget_v3_main
    .css, widget_main.js) while the markup it renders into is wrapped in
    .jdgm-legacy-widget-content. The endpoint now returns JSON rather than
    pre-rendered HTML, and the legacy render path does not appear to consume
    that shape. Proving it means switching the store to Judge.me's current
    widget, which is their call or Joe's, not something to guess from outside.

    Joe's decision, 29 Sep: take pagination over ourselves rather than wait.

    ==================================================================
    HOW IT WORKS, AND THE TWO THINGS THAT MAKE IT SAFE.

    ONE: JUDGE.ME NEVER SEES THE CLICK. The button is replaced with a clone of
    itself - which drops any listener bound to the node - and the click is
    caught in the CAPTURE phase on document and stopped there. That matters for
    more than tidiness: the app's handler is the thing that tears .jdgm-paginate
    out of the page, so as long as it never runs, the button survives and can be
    pressed again. It also saves a request that was only ever going to be
    thrown away.

    Stopping the click also stops the PDP controller's own handler in
    gt-pdp-v2.js, which used to increment data-gt-jrev-pages. So this file owns
    that attribute now, and writes it in the controller's own terms - see below.

    TWO: NEW CARDS ARE CLONES OF A CARD ALREADY ON THE PAGE, not markup written
    out here. A Judge.me review card carries stars, timestamps, buyer badges,
    variant rows and transparency badges, and gt-pdp-v2.js then decorates it
    further with .gt-jrev-top and .gt-jrev-foot. Hand-building that would be
    wrong the first time the app changes its structure, and wrong immediately
    for the decorations. Cloning the first card on the page and overwriting its
    fields is correct by construction and stays correct.

    The clone keeps data-gt-jrev="1" so paintReviewWidget() leaves it alone
    rather than trying to build a second .gt-jrev-foot around elements that are
    already inside one.

    ==================================================================
    HOW IT COOPERATES WITH THE CONTROLLER.

    gt-pdp-v2.js hides reviews past `pages x perPage` behind .gt-jrev-over,
    where perPage is 3 below 768px and 6 above, and it repaints on every DOM
    mutation inside the widget. Appending cards therefore triggers its repaint,
    so the two have to agree or the new reviews would be hidden the instant
    they arrive.

    They agree because this file writes data-gt-jrev-pages itself, as
    ceil(shown / perPage), and then applies exactly the same classes the
    controller would. The arithmetic works out exact rather than approximate:
    the reveal step is 6, which is a whole multiple of both 3 and 6, and the
    starting count is whatever the controller already had on screen.

    It also does the hiding itself rather than relying on the controller, so it
    still behaves if v2 is ever rolled back or on any page the controller does
    not run.

    ==================================================================
    ONE DELIBERATE LOSS, AND ONE DELIBERATE GUESS.

    REVIEW BODIES ARE INSERTED AS TEXT, NOT AS HTML. The payload carries
    body_html. Judge.me injects that straight into the page; this file parses it
    with DOMParser - which runs no scripts and loads no resources - takes the
    text out, and rebuilds the paragraphs. A customer review is prose, so what
    is lost is the rare inline link, and what is gained is that no third-party
    HTML is ever written into the merchant's page by us.

    PHOTOS ON FETCHED REVIEWS ARE NOT SHOWN. The clone's picture nodes belong to
    the template review, so they are removed rather than left lying. A review
    with photos still appears, with its words, without its photos. The first six
    reviews - the ones Judge.me renders itself - are unaffected, and photos are
    rare in this catalogue. Rendering them would mean guessing at the app's
    gallery markup, which is exactly the kind of guess the clone exists to
    avoid.

    The one guess that IS made is the country flag's URL, and it carries its own
    undo - see the note on it below.

    PURE ASCII, working rule 18: the theme-file connector has mangled non-ASCII
    twice.
*/
(function () {
  "use strict";

  if (window.__gtJrevMore) return;
  window.__gtJrevMore = true;

  /* Judge.me's own product_review_widget_per_page, read off jdgmSettings on
     29 Sep. It is the page size the endpoint is asked for, so a mismatch here
     would silently skip or repeat reviews. */
  var PER = 6;

  /* What one press adds. Six is the app's page size, so a press costs at most
     one request, and it is a whole multiple of the controller's 3 and 6. */
  var STEP = 6;

  var MQ = window.matchMedia("(max-width: 768px)");

  var shown = 0;          /* how many the shopper can see */
  var loadedPages = 1;    /* how many server pages are in the DOM */
  var totalPages = null;  /* learned from the first response */
  var busy = false;
  var bound = false;
  var ours = null;        /* our replacement button */

  function q(s, r) { try { return (r || document).querySelector(s); } catch (e) { return null; } }
  function qa(s, r) { try { return [].slice.call((r || document).querySelectorAll(s)); } catch (e) { return []; } }

  function widg() { return q(".jdgm-rev-widg"); }
  function cards() { var w = widg(); return w ? qa(".jdgm-rev", w) : []; }
  function listBox() {
    var w = widg();
    if (!w) return null;
    var c = cards();
    /* the element the app actually puts cards in, taken from a card rather
       than from a class name we would have to keep in step */
    return c.length ? c[0].parentNode : (q(".jdgm-rev-widg__reviews", w) || w);
  }
  function paginate() { var w = widg(); return w ? q(".jdgm-paginate", w) : null; }

  function totalReviews() {
    var w = widg();
    var n = w ? parseInt(w.getAttribute("data-number-of-reviews"), 10) : 0;
    return n > 0 ? n : 0;
  }

  function productId() {
    var host = q(".jdgm-widget[data-product-id]");
    var id = host ? host.getAttribute("data-product-id") : "";
    if (!id) { try { id = window.meta && window.meta.product && window.meta.product.id; } catch (e) {} }
    if (!id) { try { id = window.__st && window.__st.rid; } catch (e) {} }
    return id ? String(id) : "";
  }

  function shopDomain() {
    try { if (window.Shopify && window.Shopify.shop) return String(window.Shopify.shop); } catch (e) {}
    return "";
  }

  /* ---------------------------------------------------------------- */
  /* Showing and hiding, in the controller's own terms.                */

  function ctrlPer() { return MQ.matches ? 3 : 6; }

  function reveal(n) {
    var w = widg();
    if (!w) return;
    var all = cards();
    if (n > all.length) n = all.length;
    shown = n;
    w.setAttribute("data-gt-jrev-pages", String(Math.max(1, Math.ceil(n / ctrlPer()))));
    var last = null;
    all.forEach(function (r, i) {
      var over = i >= n;
      r.classList.toggle("gt-jrev-over", over);
      if (!over) last = r;
      r.classList.remove("gt-jrev-last");
    });
    if (last) last.classList.add("gt-jrev-last");
  }

  function visibleNow() {
    var all = cards();
    var n = 0, i;
    for (i = 0; i < all.length; i++) if (!all[i].classList.contains("gt-jrev-over")) n++;
    return n || all.length;
  }

  function done() {
    var all = cards().length;
    var haveAll = totalPages ? loadedPages >= totalPages : all >= totalReviews();
    return haveAll && shown >= all;
  }

  function syncButton() {
    var p = paginate();
    if (!p) return;
    p.style.display = done() ? "none" : "";
  }

  /* ---------------------------------------------------------------- */
  /* Building a card.                                                  */

  function two(n) { n = String(n); return n.length < 2 ? "0" + n : n; }

  function stamp(el, iso) {
    if (!el || !iso) return;
    var d = new Date(iso);
    if (isNaN(d.getTime())) return;
    var yyyy = d.getUTCFullYear(), mm = two(d.getUTCMonth() + 1), dd = two(d.getUTCDate());
    var hh = two(d.getUTCHours()), mi = two(d.getUTCMinutes()), ss = two(d.getUTCSeconds());
    el.setAttribute("datetime", String(iso));
    el.setAttribute("data-content", yyyy + "-" + mm + "-" + dd + " " + hh + ":" + mi + ":" + ss + " UTC");
    /* DD/MM/YY, which is the format the app is rendering on this store - read
       off a live card rather than assumed, and built from UTC parts rather
       than a locale call so it cannot drift with the visitor's browser. */
    el.textContent = dd + "/" + mm + "/" + String(yyyy).slice(2);
  }

  /* DOMParser runs no scripts and fetches nothing, so this is a safe way to
     get the words out of the app's body_html. See the header. */
  function plain(html) {
    var s = String(html == null ? "" : html);
    try {
      var doc = new DOMParser().parseFromString(s, "text/html");
      qa("br", doc.body).forEach(function (br) {
        if (br.parentNode) br.parentNode.replaceChild(doc.createTextNode("\n"), br);
      });
      qa("p, div", doc.body).forEach(function (p) { p.appendChild(doc.createTextNode("\n")); });
      return (doc.body.textContent || "").replace(/\n{3,}/g, "\n\n").trim();
    } catch (e) {
      return s.replace(/<[^>]*>/g, " ").replace(/\s+/g, " ").trim();
    }
  }

  function drop(el, sel) {
    qa(sel, el).forEach(function (n) { if (n.parentNode) n.parentNode.removeChild(n); });
  }

  function build(src, rev) {
    var el = src.cloneNode(true);

    el.setAttribute("data-review-id", String(rev.uuid || ""));
    el.setAttribute("data-verified-buyer", rev.verified_buyer ? "true" : "false");
    el.setAttribute("data-product-title", String(rev.product_title || ""));
    el.setAttribute("data-product-url", String(rev.product_url || ""));
    el.setAttribute("data-thumb-up-count", "0");
    el.setAttribute("data-thumb-down-count", "0");
    el.setAttribute("data-gt-jrev", "1");
    el.setAttribute("data-gt-jrev-added", "1");
    ["gt-jrev-open", "gt-jrev-clipped", "gt-jrev-over", "gt-jrev-last"].forEach(function (c) {
      el.classList.remove(c);
    });

    var score = Math.round(Number(rev.rating) || 0);
    if (score < 0) score = 0;
    if (score > 5) score = 5;
    var rating = q(".jdgm-rev__rating", el);
    if (rating) {
      rating.setAttribute("data-score", String(score));
      rating.setAttribute("aria-label", score + " star review");
      qa(".jdgm-star", rating).forEach(function (s, i) {
        s.classList.toggle("jdgm--on", i < score);
        s.classList.toggle("jdgm--off", i >= score);
      });
    }

    stamp(q(".jdgm-rev__timestamp", el), rev.created_at);

    /* An untitled review gets .gt-jrev-title-ghost, which gt-pdp-v2-*.css sizes
       at a reserved 1.3em so the card still lines up with a titled one beside
       it. paintReviewWidget() normally applies it, but it skips any card
       carrying data-gt-jrev - which ours does by design - so it is applied
       here. Measured without it: an untitled fetched card sat 17px short of
       its neighbour. */
    var ttl = q(".jdgm-rev__title", el);
    if (ttl) {
      var ttlText = String(rev.title || "").trim();
      ttl.textContent = ttlText;
      ttl.classList.toggle("gt-jrev-title-ghost", !ttlText);
      if (!ttlText) ttl.setAttribute("aria-hidden", "true");
      else ttl.removeAttribute("aria-hidden");
    }

    var body = q(".jdgm-rev__body", el);
    if (body) {
      body.textContent = "";
      plain(rev.body_html).split(/\n{2,}/).forEach(function (para) {
        if (!para) return;
        var p = document.createElement("p");
        para.split("\n").forEach(function (line, i) {
          if (i) p.appendChild(document.createElement("br"));
          p.appendChild(document.createTextNode(line));
        });
        body.appendChild(p);
      });
    }

    var au = q(".jdgm-rev__author", el);
    if (au) au.textContent = String(rev.reviewer_name || "");

    /* The payload's `location` already arrives parenthesised - "(Australia)" -
       and is empty for a reviewer who did not share one, which is why an empty
       location on a fetched card is the data rather than a fault. */
    var loc = q(".jdgm-rev__location", el);
    if (loc) loc.textContent = String(rev.location || "");

    /* THE FLAG, rebuilt rather than dropped, because without it a fetched card
       and one of the app's own differ at a glance. The app lazy-loads it from
       its own CDN by country code:

         <img class="jdgm-rev__location-country-flag-img jdgm--loading"
              alt="AU" data-src=".../judgeme/flags/AU.svg">

       read off a live card. The clone gets a real src rather than data-src,
       since the app's lazy loader has already been and gone by the time we
       append. Hard-coding a vendor URL is the one guess in this file, so it
       carries its own undo: if the image 404s it removes itself and the card
       simply reads as one from a reviewer who gave no country. */
    var flag = q(".jdgm-rev__location-country-flag-img", el);
    var cc = String(rev.location_country_code || "").toUpperCase();
    if (flag) {
      if (cc && /^[A-Z]{2}$/.test(cc)) {
        flag.classList.remove("jdgm--loading");
        flag.removeAttribute("data-src");
        flag.setAttribute("alt", cc);
        flag.onerror = function () { if (flag.parentNode) flag.parentNode.removeChild(flag); };
        flag.setAttribute("src", "https://public-images.judge.me/judgeme/flags/" + cc + ".svg");
      } else if (flag.parentNode) {
        flag.parentNode.removeChild(flag);
      }
    }

    var badge = q(".jdgm-rev__buyer-badge", el);
    if (badge) badge.style.display = rev.verified_buyer ? "" : "none";

    var vw = q(".jdgm-rev__prod-variant-wrapper", el);
    if (vw) {
      var val = vw.children.length > 1 ? vw.children[vw.children.length - 1] : null;
      if (rev.product_variant_title && val) {
        vw.style.display = "";
        val.textContent = String(rev.product_variant_title);
      } else {
        vw.style.display = "none";
      }
    }

    /* Everything on the clone that belonged to the TEMPLATE'S review and that
       cannot be filled from this payload. Left in place it would attribute one
       shopper's photograph, reply or badge to another. */
    drop(el, ".jdgm-rev__pics, .jdgm-rev__pic-img, .jdgm-rev__vids, .jdgm-rev__reply");
    drop(el, ".jdgm-rev__transparency-badge");
    drop(el, ".jdgm-rev__body-read-more, .jdgm-rev__custom-form");

    return el;
  }

  /* ---------------------------------------------------------------- */

  function fetchPage(p) {
    var pid = productId(), shop = shopDomain();
    if (!pid || !shop) return Promise.resolve(null);
    var u = "https://cdn.judge.me/reviews/reviews_for_widget"
      + "?url=" + encodeURIComponent(shop)
      + "&shop_domain=" + encodeURIComponent(shop)
      + "&platform=shopify"
      + "&page=" + encodeURIComponent(String(p))
      + "&per_page=" + encodeURIComponent(String(PER))
      + "&product_id=" + encodeURIComponent(pid);
    return fetch(u)
      .then(function (r) { return r.ok ? r.json() : null; })
      .catch(function () { return null; });
  }

  function append(reviews) {
    var box = listBox();
    var all = cards();
    if (!box || !all.length || !reviews || !reviews.length) return 0;
    var src = all[0];
    var seen = {};
    all.forEach(function (r) { seen[r.getAttribute("data-review-id") || ""] = 1; });
    var added = 0;
    reviews.forEach(function (rev) {
      var id = String(rev && rev.uuid || "");
      if (!id || seen[id]) return;      /* never render the same review twice */
      seen[id] = 1;
      box.appendChild(build(src, rev));
      added++;
    });
    return added;
  }

  function label(txt) {
    if (!ours) return;
    if (txt) { if (!ours.getAttribute("data-gt-was")) ours.setAttribute("data-gt-was", ours.textContent || ""); ours.textContent = txt; }
    else { var w = ours.getAttribute("data-gt-was"); if (w) { ours.textContent = w; ours.removeAttribute("data-gt-was"); } }
  }

  function more() {
    if (busy) return;
    var w = widg();
    if (!w) return;

    var want = shown + STEP;
    var have = cards().length;

    if (want <= have) { reveal(want); syncButton(); return; }
    if (totalPages && loadedPages >= totalPages) { reveal(have); syncButton(); return; }

    busy = true;
    label("Loading...");
    fetchPage(loadedPages + 1).then(function (j) {
      busy = false;
      label("");
      if (!j) { return; }               /* leave the button alone so it can be tried again */
      if (j.pagination && j.pagination.total_pages) totalPages = Number(j.pagination.total_pages);
      var added = append(j.reviews || []);
      if (added) loadedPages++;
      reveal(Math.min(want, cards().length));
      syncButton();
    }).catch(function () {
      busy = false;
      label("");
    });
  }

  /* ---------------------------------------------------------------- */

  function isMoreBtn(b) {
    return !!b && /^\s*(show|load)\s+more\s*$/i.test((b.textContent || "").replace(/\s+/g, " "));
  }

  /* Replacing the node drops every listener the app bound to it. The capture
     handler then stops anything bound by delegation. Both, because either one
     alone leaves a way for the app's handler to run and remove the block. */
  function takeButton() {
    var p = paginate();
    if (!p) return;
    var b = q("a, button", p);
    if (!b || !isMoreBtn(b)) return;
    if (b.getAttribute("data-gt-jrev-more")) { ours = b; return; }
    var clone = b.cloneNode(true);
    clone.setAttribute("data-gt-jrev-more", "1");
    clone.removeAttribute("data-page");
    clone.removeAttribute("href");
    if (b.parentNode) b.parentNode.replaceChild(clone, b);
    ours = clone;
    ours.addEventListener("click", function (e) {
      e.preventDefault();
      e.stopPropagation();
      if (e.stopImmediatePropagation) e.stopImmediatePropagation();
      more();
    });
  }

  function onCapture(e) {
    var t = e.target;
    if (!t || !t.closest) return;
    var w = widg();
    if (!w) return;
    var b = t.closest("a, button");
    if (!b || !w.contains(b) || !isMoreBtn(b)) return;
    e.preventDefault();
    e.stopPropagation();
    if (e.stopImmediatePropagation) e.stopImmediatePropagation();
    more();
  }

  /* BOUND THE MOMENT THIS FILE RUNS, not at DOMContentLoaded, and that is the
     whole reason the tag in goldtop-tokens.liquid is not deferred. A capture
     listener on document beats anything bound later, and the app's widget
     bootstraps asynchronously - so as long as ours exists first, the app's
     handler can never reach the button and can never remove the block. Waiting
     for DOMContentLoaded would very probably still be early enough, and
     "very probably" is what this project keeps being caught by. */
  document.addEventListener("click", onCapture, true);

  function start() {
    var w = widg();
    if (!w) return;
    if (!bound) {
      bound = true;
      /* The app re-renders its widget after its own bootstrap, so the button
         has to be re-taken whenever it comes back. Scoped to the widget -
         this never watches the whole document. */
      if (window.MutationObserver) {
        new MutationObserver(function () { takeButton(); syncButton(); })
          .observe(w, { childList: true, subtree: true });
      }
    }
    shown = visibleNow();
    takeButton();
    syncButton();
  }

  /* The widget is an app block that mounts late, so the same retry ladder the
     rest of this theme's files use. Each pass is two querySelectors when there
     is nothing to do. */
  function boot() {
    start();
    [400, 1200, 2500, 5000, 9000].forEach(function (d) { setTimeout(start, d); });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", boot);
  } else {
    boot();
  }
})();
